import { useContext } from "react";
import Context from "../js/Context";

const useVar = () => {
  return useContext(Context);
};

export default useVar;
